import React from 'react';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '../ui/alert-dialog';
import { Trash2, Eye } from 'lucide-react';

const MessagesTab = ({ messages, onMarkAsRead, onDeleteMessage }) => {
  return (
    <div className="bg-zinc-900 rounded-lg border border-zinc-800 p-6">
      <h2 className="text-xl font-semibold text-white mb-6">Contact Messages</h2>
      
      {messages.length === 0 ? (
        <p className="text-zinc-400 text-center py-8">No messages yet</p>
      ) : (
        <div className="space-y-4">
          {messages.map((msg) => (
            <div 
              key={msg.id} 
              className={`bg-zinc-800 rounded-lg p-4 border ${msg.read ? 'border-zinc-700' : 'border-emerald-500'}`}
            >
              <div className="flex items-start justify-between mb-2">
                <div>
                  <h3 className="text-white font-medium">{msg.subject}</h3>
                  <p className="text-zinc-400 text-sm">From: {msg.name} ({msg.email})</p>
                  <p className="text-zinc-500 text-xs">
                    {new Date(msg.created_at).toLocaleString()}
                  </p>
                </div>
                <div className="flex items-center gap-2">
                  {!msg.read && (
                    <Badge className="bg-emerald-500 text-white">New</Badge>
                  )}
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => onMarkAsRead(msg.id)}
                    className="text-blue-400 hover:text-blue-300"
                    title="Mark as read"
                  >
                    <Eye className="w-4 h-4" />
                  </Button>
                  <AlertDialog>
                    <AlertDialogTrigger asChild>
                      <Button
                        variant="ghost"
                        size="sm"
                        className="text-red-400 hover:text-red-300"
                      >
                        <Trash2 className="w-4 h-4" />
                      </Button>
                    </AlertDialogTrigger>
                    <AlertDialogContent className="bg-zinc-900 border-zinc-800">
                      <AlertDialogHeader>
                        <AlertDialogTitle className="text-white">Delete Message</AlertDialogTitle>
                        <AlertDialogDescription className="text-zinc-400">
                          Are you sure you want to delete this message?
                        </AlertDialogDescription>
                      </AlertDialogHeader>
                      <AlertDialogFooter>
                        <AlertDialogCancel className="bg-zinc-800 text-zinc-300 border-zinc-700">
                          Cancel
                        </AlertDialogCancel>
                        <AlertDialogAction
                          className="bg-red-600 hover:bg-red-700"
                          onClick={() => onDeleteMessage(msg.id)}
                        >
                          Delete
                        </AlertDialogAction>
                      </AlertDialogFooter>
                    </AlertDialogContent>
                  </AlertDialog>
                </div>
              </div>
              <p className="text-zinc-300 whitespace-pre-wrap">{msg.message}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MessagesTab;
